export const AUTH_REQUEST = 'auth/REQUEST';
export const AUTH_SUCCESS = 'auth/SUCCESS';
export const AUTH_FAILURE = 'auth/FAILURE';
export const AUTH_LOGOUT = 'auth/LOGOUT';
export const FORGOT_PASSWORD_REQUEST = 'auth/FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'auth/FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'auth/FORGOT_PASSWORD_FAILURE';

